<script setup lang="ts">
const gtm = useGtm();
const { gtag } = useGtag();
const { appEnv } = useRuntimeConfig().public;
const route = useRoute();

useHead({
  meta: [
    {
      name: "viewport",
      content: computed(() => {
        const userAgent = window?.navigator.userAgent;

        return userAgent &&
          (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i))
          ? "width=device-width, initial-scale=1, maximum-scale=1"
          : "width=device-width, initial-scale=1";
      }),
    },
  ],
  script:
    !route.path.includes("/simuladores/embed") && appEnv != "development"
      ? [
          {
            key: "cookie-information",
            type: "text/javascript",
            id: "CookieConsent",
            src: "https://policy.app.cookieinformation.com/uc.js",
            async: true,
            "data-culture": "PT",
            "data-gcm-version": "2.0",
            tagPriority: "after:script:cgg-ciab-version",
          },
        ]
      : undefined,
});

const setConsent = () => {
  const cookieConsentMarketing = window?.CookieInformation?.getConsentGivenFor(
    "cookie_cat_marketing"
  );
  const cookieConsentStatistic = window?.CookieInformation?.getConsentGivenFor(
    "cookie_cat_statistic"
  );

  gtm?.enable(cookieConsentStatistic);

  gtag("consent", "update", {
    ad_user_data: cookieConsentMarketing ? "granted" : "denied",
    ad_personalization: cookieConsentMarketing ? "granted" : "denied",
    ad_storage: cookieConsentMarketing ? "granted" : "denied",
    analytics_storage: cookieConsentStatistic ? "granted" : "denied",
  });

  // @ts-ignore
  window.uetq.push("consent", "update", {
    ad_storage: cookieConsentMarketing ? "granted" : "denied",
  });
};

onBeforeMount(() => {
  if (appEnv != "development") {
    window.addEventListener("CookieInformationConsentGiven", setConsent);
    setConsent();
  }
});

onMounted(() => {
  if (appEnv != "development") {
    window?.CookieInformation?.loadConsent();
  }
});
</script>

<template>
  <div id="top">
    <NuxtLoadingIndicator color="#076b9c" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
@include fade-transition;
</style>
